import React from "react"
import { ShopPaymentPoint } from "../../libs/api/backend/src"

interface Props {
  shopPaymentPoints: Array<ShopPaymentPoint>
  selected?: string
  handleChange: any
  className?: string
  notSelectedText?: string
}

function ShopPaymentPointSelect({
  shopPaymentPoints,
  selected = "",
  handleChange,
  className,
  notSelectedText,
}: Props) {
  let classNameValue =
    className ||
    "mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"

  return (
    <select
      id="shopPaymentPointId"
      name="shopPaymentPointId"
      className={classNameValue}
      value={selected}
      onChange={(e) => handleChange(e.target.value)}
    >
      <option value="">{notSelectedText || "Не выбрано"}</option>

      {shopPaymentPoints && shopPaymentPoints.length
        ? shopPaymentPoints.map((shopPaymentPoint) => {
            return (
              <option key={shopPaymentPoint.id} value={shopPaymentPoint.id}>
                {shopPaymentPoint.title}
              </option>
            )
          })
        : null}
    </select>
  )
}

export default ShopPaymentPointSelect
